import { useEffect, type ReactNode } from "react";

import { Banner } from "common/ui/Banner";

import styles from "./Toast.module.scss";

export type ToastVariants =
  "default"
  | "informational"
  | "critical"
  | "success"
  | "warning";

interface Props {
  children: ReactNode,
  variant: ToastVariants,
  timeout?: number, // Unit in ms
  alertIcon?: boolean
  close: () => any;
}
export function Toast({
  children,
  variant = "default",
  timeout,
  alertIcon = false,
  close
}: Props) {

  useEffect(() => {
    if(timeout) {
      const timer = setTimeout(() => {
        close();
      }, timeout);

      return () => clearTimeout(timer);
    }
  }, []);

  return (
    <div className={styles.Toast}>
      <Banner
        variant={variant}
        close={() => close()}
        alertIcon={alertIcon}
      >
        {children}
      </Banner>
    </div>
  )
}

